import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { ApiErrorResponse } from 'src/app/shared/interfaces/api-error-response';
import { passwordMatchValidator } from 'src/app/shared/validators/password-match.validator';
import { strongPasswordValidator } from 'src/app/shared/validators/password-strength.validator';
import { SubSink } from 'subsink';

import { trimInput } from '@shared/helpers/input-trim-helper';
import { isValidEmail } from '@shared/validators/email.validator';
import { phoneNumberValidator } from '@shared/validators/phone-number.validator';

@Component({
  selector: 'app-merchant-user-registration-form',
  templateUrl: './merchant-user-registration-form.component.html',
  styleUrls: ['./merchant-user-registration-form.component.scss'],
})
export class MerchantUserRegistrationFormComponent implements OnDestroy {
  @Input() merchantId!: string;
  @Input() errorResponse?: ApiErrorResponse | null;
  @Input() isLoading?: boolean | null;
  @Output() continue = new EventEmitter();
  passwordVisibility = true;
  confirmPasswordVisibility = true;

  private subs = new SubSink();

  TITLE = 'REGISTRATION.TITLE.';
  PLACEHOLDER = 'REGISTRATION.PLACEHOLDER.';

  registrationForm: UntypedFormGroup = this.fb.group(
    {
      firstName: new UntypedFormControl(null, [Validators.required]),
      lastName: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl(null, [Validators.required, isValidEmail]),
      phoneNumber: new UntypedFormControl(null, [
        Validators.required,
        phoneNumberValidator,
      ]),
      password: new UntypedFormControl(null, [
        Validators.required,
        strongPasswordValidator,
      ]),
      confirmPassword: new UntypedFormControl(null, [
        Validators.required,
        strongPasswordValidator,
      ]),
    },
    { validators: passwordMatchValidator }
  );

  constructor(private fb: UntypedFormBuilder) {}

  onSubmit(): void {
    if (this.registrationForm.valid) {
      const registrationFormValue = trimInput(this.registrationForm.value);
      this.continue.emit({
        merchantId: this.merchantId,
        firstName: registrationFormValue.firstName,
        lastName: registrationFormValue.lastName,
        email: registrationFormValue.email,
        phoneNumber: registrationFormValue.phoneNumber,
        password: registrationFormValue.password,
      });
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
